export default class HttpRequest {
    method: string
    path: string
    body: object

    constructor(method: string, path: string, body: object = {}) {
        this.method = method.toUpperCase()
        this.path = path
        this.body = body
    }
}
